<template>
  <div>
    <b-modal
      title="DETALHES DA VENDA"
      id="details"
      size="lg"
      hide-footer
      no-close-on-backdrop
    >
      <details-stock-sale :stock_sale="stock_sale" />
    </b-modal>
    <b-modal
      title="GERAR MOVIMENTAÇÃO NA CONTA CORRENTE DO RESIDENTE"
      id="status"
      hide-footer
      no-close-on-backdrop
    >
      <status-rest-home-sale-resident
        :stock_sale="stock_sale"
        @success="paginate"
      />
    </b-modal>
    <b-modal id="filter" no-close-on-backdrop hide-footer title="FILTRAR">
      <div class="row">
        <div class="col-md-12 pt-0 pb-0">
          <label class="m-0">STATUS</label>
          <v-select
            :items="[
              { value: null, text: 'TODOS' },
              { value: 1, text: 'FATURAMENTO PENDENTE' },
              { value: 0, text: 'FATURADO' },
            ]"
            v-model="status"
            dense
            label=""
            outlined
            hide-details
            item-value="value"
            item-text="text"
          />
        </div>
        <div class="col-md-6">
          <label>DATA INICIAL</label>
          <input type="date" v-model="start" class="form-control" />
        </div>
        <div class="col-md-6">
          <label>DATA FINAL</label>
          <input type="date" v-model="end" class="form-control" />
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
          <v-btn @click="handleFilter" class="btn-filter" type="relief">
            <i class="fas fa-filter mr-2 text-twenty"></i>
            FILTRAR
          </v-btn>
        </div>
      </div>
    </b-modal>
    <div class="row">
      <div class="col-md-12 text-right">
        <v-btn
          @click="$bvModal.show('filter')"
          class="btn-filter mr-2"
          type="relief"
        >
          <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
        </v-btn>
      </div>
      <div class="col-md-12">
        <b-overlay :show="loading" opacity="0.99">
          <div v-show="data.length === 0" class="v-clean p-5">
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>
          <v-data-table
            v-show="data.length > 0"
            dense
            :headers="headers"
            :items="data"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            :options.sync="options"
            :server-items-length="total"
          >
            <template v-slot:[`item.status`]="{ item }">
              <div
                v-if="item.status == 0"
                class="d-flex align-items-center justify-content-center"
              >
                <span>FATURADO</span>
                <v-icon class="ml-2" small color="success">
                  mdi-check-circle-outline
                </v-icon>
              </div>
              <div
                v-else
                class="d-flex align-items-center justify-content-center"
              >
                <span>FATURAMENTO PENDENTE</span>
                <v-icon class="ml-2" small color="orange">
                  mdi-information-outline
                </v-icon>
              </div>
            </template>
            <template v-slot:[`item.medicine`]="{ item }">
              {{ item.medicine_name }}
            </template>
            <template v-slot:[`item.stock_group`]="{ item }">
              {{ item.stock_group_name }}
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              {{ item.amount }}
              {{ item.stock_item_unit_of_measurement_abbreviation }}
            </template>
            <template v-slot:[`item.value`]="{ item }">
              {{ formatReal(item.value) }}
            </template>
            <template v-slot:[`item.entry_date`]="{ item }">
              {{ moment(item.entry_date).format("DD/MM/YYYY") }}
            </template>
            <template v-slot:[`item.details`]="{ item }">
              <v-btn small class="btn-primary m-1" @click="handleDetails(item)">
                <i class="fas fa-eye mr-2"></i>DETALHES
              </v-btn>
              <!-- <v-btn
                v-if="
                  item.status == 1 &&
                  permission('write', 'resident_rest_home_sale_resident')
                "
                small
                class="btn-i m-1"
                @click="handleStatus(item)"
              >
                <i class="fas fa-check mr-2"></i>MOVIMENTAÇÃO
              </v-btn> -->
            </template>
          </v-data-table>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";

import DetailsStockSale from "./menu-rest-home-sale-resident/details.vue";

import StatusRestHomeSaleResident from "./menu-rest-home-sale-resident/status.vue";

import api from "../../../../services/api";

import routes from "../../../../routes";

import { formatReal } from "../../../../lib/format";

import moment from "moment";

import permission from "../../../../lib/permission";

export default {
  name: "RestHomeSaleResident",

  components: {
    ErrorsMessages,
    DetailsStockSale,
    StatusRestHomeSaleResident,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      status: null,
      stock_sale_id: "",
      resident_id: "",
      start: moment().subtract(30, "days").format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),

      total: 0,
      options: {},

      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "MEDICAMENTO", value: "medicine", sortable: false },
        { text: "GRUPO", value: "stock_group", sortable: false },
        { text: "LOTE", value: "lot", sortable: false },
        { text: "QTD", value: "amount", sortable: false },
        { text: "VALOR", value: "value", sortable: false },
        { text: "DATA DA VENDA", value: "entry_date", sortable: false },
        { text: "DETALHES", value: "details", sortable: false },
      ],

      data: [],
      stock_sale: {},

      loading: false,

      errors: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    moment,
    formatReal,
    permission,

    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      this.paginate();
    },

    handleDetails(stock_sale) {
      this.stock_sale = stock_sale;
      this.$bvModal.show("details");
    },

    handleStatus(stock_sale) {
      this.stock_sale = stock_sale;
      this.$bvModal.show("status");
    },

    handleFilter() {
      this.options.page = 1;
      this.paginate();
    },

    async paginate() {
      try {
        this.loading = true;

        let { resident_id, stock_sale_id, start, end, status } = this;

        const { page, itemsPerPage, sortBy, sortDesc } = this.options;

        let params = {
          resident_id,
          stock_sale_id,
          start,
          end,
          status,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
        };

        const response = await api.get(
          "/rest-home/family/menu-rest-home-sales-resident",
          {
            params,
          }
        );

        const { error, errors, data, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
          this.total = total;
          this.$bvModal.hide("filter");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
